import {Component, OnInit} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { GetUserGroups, ResetUserGroups } from './store/actions/user-groups-list.actions';
import { BzgModalRef, BzgModalService } from 'bz-genome-angular';
import { Observable, Subscription } from 'rxjs';
import { SavePendingChangesComponent } from '../../shared/components/save-pending-changes/save-pending-changes.component';
import { EHasChangesStatus, EPendingChangesSelectedAction } from 'app/core/models/pending-changes.enum';
import { selectHasChanges } from 'app/core/store/selectors/pending-changes.selector';
import { pendingChangesAction, ResetPendingChangesState } from 'app/core/store/actions/pending-changes.actions';
import { IAppState } from 'app/IAppState';

@Component({
    selector: 'user-groups',
    templateUrl: 'user-groups.component.html',
    styleUrls: ['user-groups.component.scss']
})
export class UserGroupsComponent implements OnInit{
  public modalRef: BzgModalRef;
  private _hasChanges$: Observable<EHasChangesStatus>;
  private _hasChangesSubscription: Subscription;
  private _menuOptionsSubscription: Subscription;
  public menuOptions = {};
  constructor(private _store: Store<IAppState>, private _modalService: BzgModalService) {
    this._hasChanges$ = this._store.pipe(select(selectHasChanges));
  }

  ngOnInit() {
       this._menuOptionsSubscription = this._store
            .select((s) => s.menuOptions)
            .subscribe((menuOptions: any) => {
                this.menuOptions = menuOptions['UserGroups'];
        });
    this._store.dispatch(new GetUserGroups());
    this._hasChangesSubscription = this._hasChanges$.subscribe((status: number) => {
      switch (status) {
        case  EHasChangesStatus.HASCHANGES:
          this.modalRef = this._modalService.open(SavePendingChangesComponent, {closeOnRouterNavigation: true,});
          this.modalRef.afterClosed().subscribe(result => {
            switch (result.action) {
              case 'cancel':
              this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.CANCEL));
                break;
              case 'dontsave':
                this.modalRef.close();
                this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.CONTINUE));
                break;
              case 'save':
              this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.SAVE));
                this.modalRef.close();
                break;
              case 'close':
              this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.CANCEL));
                this.modalRef.close();
                break;
            }
          });
        break;
      case  EHasChangesStatus.DONTHASCHANGES :
        this._store.dispatch(new pendingChangesAction(EPendingChangesSelectedAction.CONTINUE));
        break;
      }
    });
  }

  ngOnDestroy() {
    this._store.dispatch(new ResetUserGroups());
    this._menuOptionsSubscription.unsubscribe();
    this._store.dispatch(new ResetPendingChangesState());
    if (this._hasChangesSubscription) {
      this._hasChangesSubscription.unsubscribe();
    }
  }

}
